import React from 'react';
import { Icon } from './Icon.js';
export const IconArchiveFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.75.5H3.25C1.733.5.5,1.733.5,3.25v5.5c0,1.517,1.233,2.75,2.75,2.75h5.5c1.517,0,2.75-1.233,2.75-2.75V3.25c0-1.517-1.233-2.75-2.75-2.75Zm-5.5,1.5h5.5c.69,0,1.25.56,1.25,1.25v2.75h-1.25c-.414,0-.75.336-.75.75v1.25h-4v-1.25c0-.414-.336-.75-.75-.75h-1.25v-2.75c0-.69.56-1.25,1.25-1.25Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconArchiveFill12.js.map